<template>
  <div class="agency_recommd container">
    <div class="container-head">
      <div class="head-left">
        <div class="icon">
          <img :src="datainfo.icon" />
        </div>
        {{ datainfo.title }}
      </div>
    </div>
    <div class="zixun">
      <div class="zixun_item">
        <div
          class="zx_img"
          :style="{
            backgroundImage: 'url(' + datainfo.pagevalue.photopath + ')'
          }"
        >
          <img :src="datainfo.pagevalue.photopath" />
        </div>
        <div class="zx_info">
          <div class="info_name">
            {{ datainfo.pagevalue.title }}
          </div>
          <div class="info_desc">{{ datainfo.pagevalue.subtitle }}</div>
          <div class="info_btn" @click="gonewdetail(datainfo.pagevalue.id)">
            点击了解详情
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["datainfo"],
  methods: {
    gonewdetail(id) {
      //   uni.navigateTo({
      //     url: "/pages/news-detail/news-detail?id=" + id
      //   });
      this.$router.push({
        path: "newsdetail",
        query: {
          id: id
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.agency_recommd {
  flex-direction: column;
}
.zixun {
  width: 100%;

  .zixun_item {
    padding: 0.3rem;
    width: 100%;
    height: auto;
    background: #f6fbff;
    border-radius: 0.12rem;
    display: flex;

    .zx_img {
      width: 2.71rem;
      height: auto;
      margin-right: 0.67rem;
      background-position: center center;
      background-size: cover;
      background-repeat: no-repeat;
      border-radius: 0.1rem;
      @media (max-width: 991px) {
        margin-right: 0.3rem;
        width: 2.71rem;
        height: 2.6rem;
      }

      img {
        width: 100%;
        height: 100%;
        opacity: 0;
      }
    }

    .zx_info {
      flex-direction: column;
      width: 6.55rem;

      .info_name {
        margin-top: 0.1rem;
        font-size: 0.24rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #5e5e66;
        line-height: 0.42rem;
        margin-bottom: 0.17rem;
        overflow: hidden;
        height: 0.42rem;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        text-align: left;
        @media (max-width: 991px) {
          font-size: 0.3rem;
          line-height: 0.42rem;
          height: 0.84rem;
          font-weight: bolder;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
        }
      }

      .info_desc {
        font-size: 0.18rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #5e5e66;
        line-height: 0.25rem;
        margin-bottom: 0.25rem;
        text-align: left;
        @media (max-width: 991px) {
          font-size: 0.26rem;
          line-height: 0.32rem;
          height: 0.64rem;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          display: -webkit-box;
        }
      }

      .info_btn {
        width: 4rem;
        height: 0.6rem;
        line-height: 0.6rem;
        font-size: 0.24rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1395ff;
        text-align: center;
        justify-content: center;
        border-radius: 0.3rem;
        border: 1px solid #1395ff;
        cursor: pointer;
        @media (max-width: 991px) {
          width: 2.62rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/anews.vue